const transformTemplate = '/w_150/';
const defaultWidth = 100;

export enum ChildImageVariantEnum {
  Full = 'full',
  Portrait = 'portrait',
  Thumb = 'thumb',
  Circle = 'circle',
  Landscape = 'landscape',
  MediumShot = 'medium',
}

const imageTransforms: {
  [variant in ChildImageVariantEnum]: {
    transform: string;
  };
} = {
  [ChildImageVariantEnum.Full]: {
    transform: 'f_auto,q_auto',
  },
  [ChildImageVariantEnum.Portrait]: {
    transform: 't_portrait/f_auto,q_auto',
  },
  [ChildImageVariantEnum.Thumb]: {
    transform: 't_thumb/f_auto,q_auto',
  },
  [ChildImageVariantEnum.Circle]: {
    transform: 't_thumb/f_auto,q_auto',
  },
  [ChildImageVariantEnum.MediumShot]: {
    transform: 'c_crop,g_face,w_0.75,ar_1:1/f_auto,q_auto',
  },
  [ChildImageVariantEnum.Landscape]: {
    // 3-stage transform: first creates a square around face, second puts the face in the upper 1/3, 3rd is manipulated by the loader
    transform:
      'c_fill,g_face,ar_1:1/c_crop,g_north,ar_16:9,w_iw,y_133/f_auto,q_auto',
  },
};

export const getChildImageUrlBase = (
  imageUrl: string,
  variant: ChildImageVariantEnum,
  width?: number,
) => {
  if (!imageUrl || !imageUrl.includes(transformTemplate)) {
    return null;
  }
  return imageUrl.replace(
    transformTemplate,
    `/${imageTransforms[variant].transform}${width ? `,w_${width}` : ''}/`,
  );
};

export const getChildImageUrl = (
  imageUrl: string,
  variant: ChildImageVariantEnum,
  width = defaultWidth,
) => {
  if (!imageUrl || !imageUrl.includes(transformTemplate)) {
    return null;
  }

  return getChildImageUrlBase(imageUrl, variant, width);
};
